import { render } from "./BulkRemoveModal.vue?vue&type=template&id=5f9026e0&scoped=true"
import script from "./BulkRemoveModal.vue?vue&type=script&lang=js"
export * from "./BulkRemoveModal.vue?vue&type=script&lang=js"

import "./BulkRemoveModal.vue?vue&type=style&index=0&id=5f9026e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9026e0"]])

export default __exports__